import cn from "classnames";
import Loader from "components/shared/loader";
import { feedbackTagFlagsEnum } from "helpers/enums";
import without from "lodash/without";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import { list } from "sources/books/admin/feedbackTags";
import { apply } from "sources/feedbacks";

const STARS_COUNT = 5;

const rateTextByGrade = (grade) => {
    if (grade === 5) {
        return "Что вам понравилось?";
    } else if (grade < 3) {
        return "Что вам не понравилось?";
    } else {
        return "Оцените водителя";
    }
};

export default function DriverRate(props) {
    const [currentIndex, setCurrentIndex] = useState(props.feedback?.grade);
    const [, setTimeoutId] = useState(null);

    if (!props.feedback && !props.canApplyFeedback) {
        return null;
    }

    const mouseEnterHandle = (i) => {
        if (!props.canApplyFeedback) {
            return;
        }
        setTimeoutId(clearTimeout);
        setCurrentIndex(i + 1);
    };

    const resetIndex = () => {
        if (!props.canApplyFeedback) {
            return;
        }
        setTimeoutId(
            setTimeout(() => {
                setCurrentIndex(props.feedback?.grade);
            }, 300),
        );
    };

    const rateHandle = () => {
        if (!props.canApplyFeedback) {
            return;
        }
        props.modal({
            title: rateTextByGrade(currentIndex),
            name: "default",
            windowMod: "sm",
            CustomBody: (rest) => (
                <SelectFeedbackTags
                    {...rest}
                    bidId={props.bidId}
                    grade={currentIndex}
                    refreshBidData={props.refreshBidData}
                />
            ),
        });
    };

    const stars = () => {
        return new Array(STARS_COUNT).fill().map((_, i) => (
            <i
                key={i}
                className={cn("pr-1 icon-uEABA-star-solid", {
                    "text-brand": i < currentIndex,
                    "cursor-pointer": props.canApplyFeedback,
                })}
                onMouseEnter={mouseEnterHandle.bind(null, i)}
                onMouseLeave={resetIndex}
                onClick={rateHandle}
            />
        ));
    };

    return (
        <div className="text-muted">
            {props.feedback?.colleague ? (
                <Tooltip placement="top" overlay={`Оценил: ${props.feedback.colleague.shortName}`}>
                    <div className="d-inline-block">{stars()}</div>
                </Tooltip>
            ) : (
                stars()
            )}
        </div>
    );
}

function SelectFeedbackTags(props) {
    const [selectedTags, setSelectedTags] = useState([]);
    const [allTags, setAllTags] = useState([]);
    const [groupedTags, setGroupedTags] = useState({
        [feedbackTagFlagsEnum.Positive]: [],
        [feedbackTagFlagsEnum.Negative]: [],
    });
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const flags = [feedbackTagFlagsEnum.ForLogist];
        if (props.grade === 5) {
            flags.push(feedbackTagFlagsEnum.Positive);
        } else if (props.grade < 3) {
            flags.push(feedbackTagFlagsEnum.Negative);
        } else {
            flags.push(feedbackTagFlagsEnum.Positive, feedbackTagFlagsEnum.Negative);
        }
        list(flags).then((res) => {
            if (res.length === 0) {
                return handleSave();
            }
            setAllTags(res);
            setGroupedTags({
                [feedbackTagFlagsEnum.Positive]: res.filter((tag) => tag.flags.includes(feedbackTagFlagsEnum.Positive)),
                [feedbackTagFlagsEnum.Negative]: res.filter((tag) => tag.flags.includes(feedbackTagFlagsEnum.Negative)),
            });
            setLoading(false);
        });
    }, []);

    const toggleTag = (id, newValue) => {
        if (newValue) {
            setSelectedTags([...selectedTags, id]);
        } else {
            setSelectedTags(without(selectedTags, id));
        }
    };

    const renderTags = (tags) => {
        return tags.map((tag) => {
            const isSelected = selectedTags.includes(tag.id);
            return (
                <div
                    key={tag.id}
                    onClick={() => toggleTag(tag.id, !isSelected)}
                    className={cn("b-filter__tag--wrap", {
                        "b-filter__tag--wrap-disabled": !isSelected && selectedTags.length === 3,
                        "b-filter__tag--wrap-selected": isSelected,
                    })}
                >
                    {isSelected ? (
                        <span className="b-filter__tag--delete" />
                    ) : (
                        <span className="b-filter__tag--checkbox" />
                    )}
                    <span className="b-filter__tag--text">{tag.name}</span>
                </div>
            );
        });
    };

    const handleSave = () => {
        setLoading(true);
        apply({ bidId: props.bidId, grade: props.grade, tagIds: selectedTags }).then((res) => {
            if (res) {
                props.refreshBidData();
                props.back();
            } else {
                setLoading(false);
            }
        });
    };

    const renderButton = () => {
        return (
            <div className="d-flex justify-content-end">
                <div className="btn btn-sm btn-brand" onClick={handleSave}>
                    Сохранить
                </div>
            </div>
        );
    };

    if (loading) {
        return <Loader />;
    }

    if (props.grade === 5 || props.grade < 3) {
        return (
            <div className="pt-4">
                {renderTags(allTags)}
                {renderButton()}
            </div>
        );
    }

    return (
        <div className="pt-4">
            {groupedTags[feedbackTagFlagsEnum.Positive].length > 0 && (
                <div className="pb-3">
                    <div className="text-muted pb-1">Отметьте положительные качества</div>
                    {renderTags(groupedTags[feedbackTagFlagsEnum.Positive])}
                </div>
            )}
            {groupedTags[feedbackTagFlagsEnum.Negative].length > 0 && (
                <div className="pb-3">
                    <div className="text-muted pb-1">Отметьте отрицательные качества</div>
                    {renderTags(groupedTags[feedbackTagFlagsEnum.Negative])}
                </div>
            )}
            {renderButton()}
        </div>
    );
}
